export default {
  MANAGE: 'MANAGE',
  EVENTS: 'EVENTS',
  PERFORMANCE: 'PERFORMANCE',
  CRM: 'CRM',
  SETTINGS: 'SETTINGS',
  //PROMOTER APP
  PROMOTER_EVENTS: 'PROMOTER_EVENTS',
  PROMOTER_SALES: 'PROMOTER_SALES'
};



// WEBPACK FOOTER //
// ./src/constants/sidebarLinks.js